module.exports = __webpack_public_path__ + "static/media/IMG_1639.d2fcf659.JPG";